import {host_haiji_url} from '@/api/host'

var stickerApi = {
    //贴纸生成
    getStickerLogsUrl: `${host_haiji_url}/v1/admin/sticker-logs`,//获取贴纸生成列表
    getStickerLogsBatchUrl: `${host_haiji_url}/v1/admin/batch/sticker-logs`,//获取贴纸批次
    getStickerStatusUrl: `${host_haiji_url}/v1/admin/sticker/status/`,//获取贴纸状态
    exportStickerUrl: `${host_haiji_url}/v1/admin/oss/url`,//获取贴纸导出oss链接
    //贴纸列表
    getStickerListUrl: `${host_haiji_url}/v1/admin/stickers`,//获取贴纸列表
    //贴纸详情
    getStickerRecordsUrl: `${host_haiji_url}/v1/admin/sticker_query_records/traceable_codes`,//获取贴纸查询记录列表
    editScoreUrl: `${host_haiji_url}/v1/admin/stickers/score`,//修改积分
    newStickerListUrl: `${host_haiji_url}/v1/admin/stickers/code`,//获取记录
    getQipaGoodsListUrl: `${host_haiji_url}/v1/admin/goods/list`,//获取奇葩熊商品列表
    setQipaGoodsTraceUrl: `${host_haiji_url}/v1/admin/goods/set_trace`,//获取奇葩熊商品列表
    getStickerLogsExportUrl: `${host_haiji_url}/v1/admin/sticker-logs/export`,//重新触发导出execl

    // 获取平台权限
    getPlatformPermissionUrl: `${host_haiji_url}/v1/admin/platform/account`, // 当前用户有权限的平台列表

    // 串货可疑列表
    getCrossDoubtListUrl: `${host_haiji_url}/v1/admin/sticker/cross-doubt/list`, // 窜货可疑列表
};

export {stickerApi}
